import { Component } from 'react';
import { C } from '../constants';

export default class ErrorBoundary extends Component {
  state = { error: null };

  static getDerivedStateFromError(error) {
    return { error };
  }

  render() {
    if (this.state.error) {
      return (
        <div
          style={{
            background: C.bg,
            minHeight: '100vh',
            color: C.white,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '2rem',
            fontFamily: "'Poppins', sans-serif",
          }}
        >
          <div style={{ fontSize: '2.5rem', marginBottom: '1rem' }}>⚠</div>
          <div style={{ fontWeight: 700, fontSize: '1.3rem', marginBottom: '0.5rem' }}>
            Something went wrong
          </div>
          <div
            style={{
              color: C.textDim,
              fontSize: '0.9rem',
              marginBottom: '2rem',
              maxWidth: 420,
              textAlign: 'center',
              lineHeight: 1.6,
            }}
          >
            {this.state.error.message}
          </div>
          <button
            onClick={() => window.location.reload()}
            style={{
              background: `linear-gradient(135deg, ${C.cyan}, ${C.pink})`,
              color: C.bg,
              border: 'none',
              padding: '0.8rem 1.8rem',
              borderRadius: 12,
              fontWeight: 700,
              cursor: 'pointer',
              fontSize: '0.95rem',
              fontFamily: "'Poppins', sans-serif",
            }}
          >
            Reload page
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
